import PropTypes from 'prop-types'
import styled from '@emotion/styled'

import { ReactComponent as ArrowUpIcon } from '@doveconviene/sf-ui/icons/arrow_up.svg'
import { ReactComponent as ArrowDownIcon } from '@doveconviene/sf-ui/icons/arrow_down.svg'

const StyledRoot = styled.div(() => ({
  position: 'relative',
  width: '100%',
  padding: '6px 0 20px',
}))

const StyledButton = styled.div(({ theme: { colors, spaces } }) => ({
  color: colors.primary,
  padding: spaces.default / 2,
  border: `2px solid ${colors.primary}`,
  borderRadius: spaces.large,
  cursor: 'pointer',
  width: '150px',
  margin: '0 auto',
  display: 'flex',
  justifyContent: 'center',
}))

const StyledLabel = styled.p(({ theme: { spaces } }) => ({
  fontSize: spaces.default * 0.75,
  fontWeight: 'bold',
  margin: 0,
}))

const StyledArrow = styled.div(({ theme: { colors } }) => ({
  fill: colors.primary,
  display: 'inline-block',
  width: '24px',
  height: '24px',
  margin: '-2px 0 0 4px',
}))

const ProductsShowAllCta = ({
  expandProductsLabel, collapseProductsLabel, isBlockExpanded, onExpandProductsClick,
}) => (
  <StyledRoot>
    <StyledButton onClick={onExpandProductsClick}>
      <StyledLabel>
        { isBlockExpanded ? collapseProductsLabel : expandProductsLabel }
      </StyledLabel>
      <StyledArrow>
        { isBlockExpanded ? <ArrowUpIcon /> : <ArrowDownIcon /> }
      </StyledArrow>
    </StyledButton>
  </StyledRoot>
)

ProductsShowAllCta.propTypes = {
  expandProductsLabel: PropTypes.string,
  collapseProductsLabel: PropTypes.string,
  isBlockExpanded: PropTypes.bool,
  onExpandProductsClick: PropTypes.func,
}

ProductsShowAllCta.defaultProps = {
  expandProductsLabel: '',
  collapseProductsLabel: '',
  isBlockExpanded: false,
  onExpandProductsClick: () => false,
}

export default ProductsShowAllCta
